<p *ngIf="isExpired()" style="color: red;"><strong>Your credential(s) will be listed as expired. Are you sure you want to continue?</strong></p>
<form [formGroup]="stateLicensureForm" (ngSubmit)="onSubmit()">
	<fieldset>
		<legend>Send to State Licensure Agency</legend>
		<div class="field ">
			<div class="field__label-input-wrap ">
				<label for="agency" class="label">
					State Licensure Agency
				</label>
				<select class="input input--select-menu input--large" id="agencyId" name="agencyId" [class.input--invalid]="formErrors.agencyId" formControlName="agencyId">
				        <option value="">Select One</option>
				        <option *ngFor="let a of agencies" [value]="a.id">{{a.agencyName}}</option>
				</select>
				<div *ngIf="formErrors.agencyId" class="error-message field__error-message">{{ formErrors.agencyId }}</div>
			</div>
		</div>
		<div class="data-item" *ngIf="selectedAgency">
			<div class="data-item__label label">Send To:</div>
			<div class="data-item__value">
				<div>{{selectedAgency.agencyName}}</div>
<!-- 				<div>{{selectedAgency.addressLine1}}</div>
				<div *ngIf="selectedAgency.addressLine2">{{selectedAgency.addressLine2}}</div>
				<div>{{selectedAgency.city}}, {{selectedAgency.stateCode}} {{selectedAgency.zip}}</div> -->
			</div>
		</div>

		<div class="form-actions form-actions--multi-step">
			<input class="button form-actions__item form-actions__item--continue" type="submit" value="Continue" />
			<button (click)="onBack($event)" class="button button--secondary form-actions__item form-actions__item--back">Back</button>
		</div>
	</fieldset>
</form>